
import React, { useState } from "react";
import TopNav from "../Navbars/TopNav";
import Sidebar from "../Navbars/sidebar";

function FinalAssessmentForm() {
  const [formValues, setFormValues] = useState({
    siwessPeriod: "",
    year: "",
    traineesName: "",
    idNo: "",
    discipline: "",
    divisionDept: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedFile(reader.result); // Set the uploaded image as a preview
      };
      reader.readAsDataURL(file); // Read the file as a Data URL
    }
  };
  
  const handleRemoveFile = () => {
    setUploadedFile(null); // Remove the previewed image
    document.getElementById('signatureUpload').value = ''; // Reset the file input field
  };
  

  return (
    <>
      {/* <TopNav /> */}
      <div className="flex overflow-hidden h-screen">
        {/* Sidebar - fixed */}
        {/* <Sidebar sidebarOpen={false} setSidebarOpen={() => {}} /> */}
        
        {/* Main content - scrollable */}
        <div className="w-[80%] h-screen overflow-y-auto mt-8 mx-auto">
          <div className="bg-white rounded-xl shadow p-4 sm:p-7 dark:bg-neutral-900">
            <form>
              <div className="grid sm:grid-cols-12 gap-2 sm:gap-4 py-8">
                {/* Header */}
                <div className="sm:col-span-12 text-center">
                  <h1 className="text-xl font-bold">FINAL ASSESSMENT FORM</h1>
                </div>

                {/* Input Fields */}
                <div className="sm:col-span-12 border rounded-lg p-4">
                  <div className="grid grid-cols-1 gap-4">
                    {/* SIWES PERIOD and YEAR */}
                    <div className="flex gap-4 mb-4">
                      <div className="flex-1">
                        <label
                          htmlFor="siwessPeriod"
                          className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                        >
                          SIWES PERIOD:
                        </label>
                        <input
                          type="text"
                          id="siwessPeriod"
                          name="siwessPeriod"
                          value={formValues.siwessPeriod}
                          onChange={handleInputChange}
                          className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                        />
                      </div>
                      <div className="flex-1">
                        <label
                          htmlFor="year"
                          className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                        >
                          YEAR:
                        </label>
                        <input
                          type="text"
                          id="year"
                          name="year"
                          value={formValues.year}
                          onChange={handleInputChange}
                          className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                        />
                      </div>
                    </div>

                    {/* Trainee's Name, ID No, Discipline */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label
                          htmlFor="traineesName"
                          className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                        >
                          TRAINEE'S NAME:
                        </label>
                        <input
                          type="text"
                          id="traineesName"
                          name="traineesName"
                          value={formValues.traineesName}
                          onChange={handleInputChange}
                          className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="idNo"
                          className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                        >
                          ID No:
                        </label>
                        <input
                          type="text"
                          id="idNo"
                          name="idNo"
                          value={formValues.idNo}
                          onChange={handleInputChange}
                          className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="discipline"
                          className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                        >
                          DISCIPLINE:
                        </label>
                        <input
                          type="text"
                          id="discipline"
                          name="discipline"
                          value={formValues.discipline}
                          onChange={handleInputChange}
                          className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                        />
                      </div>
                    </div>

                    {/* Division/Dept */}
                    <div>
                      <label
                        htmlFor="divisionDept"
                        className="block text-sm font-medium text-gray-900 dark:text-neutral-500"
                      >
                        DIVISION/DEPT:
                      </label>
                      <input
                        type="text"
                        id="divisionDept"
                        name="divisionDept"
                        value={formValues.divisionDept}
                        onChange={handleInputChange}
                        className="w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400"
                      />
                    </div>

                    {/* Note */}
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-900 dark:text-neutral-500">
                        NOTE: To be filled by The Supervisor, The following
                        report outlines the trainee's qualities and attributes
                        demonstrated on the job during the attachment/training
                        period.
                      </label>
                    </div>

                    {/* Key */}
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-900 dark:text-neutral-500">
                        KEY: A: stands for 5 points B: 4 points C: 3 points D:
                        2 points E: 1 point
                      </label>
                    </div>


                    <div className="mt-8 text-center">
                      <h2 className="text-lg font-semibold">
                        PLEASE TICK ONE
                      </h2>
                    </div>

                    {/* NEW BOX FOR APTITUDE & ATTITUDE */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      {/* APTITUDE */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">APTITUDE</h3>
                        <div className="mt-2 space-y-2">
                          {/* A-E Options */}
                          <div className="flex justify-between items-center">
                            <span>A Readily grasps and applies new skill</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>B Good grasp of the basic activity</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>C Performs activity adequately</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>D Generally poor performance</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>E Unable to master the task</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* ATTITUDE */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">ATTITUDE</h3>
                        <div className="mt-2 space-y-2">
                          {/* A-E Options */}
                          <div className="flex justify-between items-center">
                            <span>A Shows exceptional keenness and interest</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>B A good keen worker</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>C Readily grasps and applies new skill</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>D Generally interested but may slack occasionally</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>E Seldom grasps and applies new skill</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* NEW BOXES FOR TIME KEEPING AND TIDINESS/SAFETY*/}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      {/* New Box for TIMEKEEPING */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">
                          TIME KEEPING
                        </h3>
                        <div className="mt-2 space-y-2">
                          {/* A-E Options */}
                          <div className="flex justify-between items-center">
                            <span>A Always punctual </span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>B Very rarely late</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>C Occasionally late</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>D Quite often late</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>E Constantly late</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* New Box for TIDINESS/SAFETY */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">
                          TIDINESS/SAFETY
                        </h3>
                        <div className="m]t-2 space-y-2">
                          {/* A-E Options */}
                          <div className="flex justify-between items-center">
                            <span>A Very methodical and tidy worker </span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>B A tidy worker</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>C Ocassionally untidy</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>D Often untidy</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>E Untidy and unsafe worker</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                     {/* NEW BOXES FOR COMMUNICATION AND CONDUCT */}
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      {/* New Box for COMMUNICATION */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">
                          COMMUNICATION 
                        </h3>
                   
  {/* Headers for Oral and Written */}
  <div className="grid grid-cols-3 mt-2 font-semibold">
    <span></span> {/* Empty space for alignment */}
    <span className="text-center">ORAL</span>
    <span className="text-center">WRITTEN</span>
  </div>

  {/* A-E Options with 2 checkboxes (ORAL, WRITTEN) */}
  <div className="mt-2 space-y-2">
    {/* Row for A Excellent */}
    <div className="grid grid-cols-3 items-center">
      <span>A Excellent</span>
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
    </div>
                        
    <div className="grid grid-cols-3 items-center">
      <span>B Very Good</span>
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
    </div>
                           {/* Row for C Good */}
    <div className="grid grid-cols-3 items-center">
      <span>C Good</span>
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
    </div>

                           {/* Row for D Fair */}
    <div className="grid grid-cols-3 items-center">
      <span>D Fair</span>
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
    </div>
      {/* Row for E Poor */}
      <div className="grid grid-cols-3 items-center">
      <span>E Poor</span>
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
      <input
        type="checkbox"
        className="rounded focus:ring-0 focus:outline-none text-green-500 justify-self-center"
        style={{ accentColor: "green" }}
      />
    </div>
  </div>
</div>
                      {/* New Box for CONDUCT */}
                      <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-semibold">
                          CONDUCT
                        </h3>
                        <div className="mt-4 space-y-2">
                          {/* A-E Options */}
                          <div className="flex justify-between items-center">
                            <span>A Sensible and calm manner</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>B Sensible</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>C Occasionally influenced by others</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>D Causes unrest, distract other co-workers</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                          <div className="flex justify-between items-center">
                            <span>E A continual troublemaker</span>
                            <input
                              type="checkbox"
                              className="rounded focus:ring-0 focus:outline-none text-green-500"
                              style={{ accentColor: "green" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* New Section for FOR OFFICIAL USE ONLY */}
<div className="border rounded-lg p-4 mt-6">
  <h3 className="text-lg font-semibold">
    {"(FOR OFFICIAL USE ONLY)"}
  </h3>
  
  {/* SCORE: Points Earned with input and division section */}
  <div className="mt-4 flex justify-center space-x-4 ">
    <span className="font-semibold">SCORE: Points Earned</span>
    <input
      type="number"
      className="w-16 border rounded p-2 focus:ring-0 focus:outline-none"
    />
    <span className="text-semiBoldText">/</span>
    <div className="flex flex-col items-center">
      <span className="font-semibold">Max Points</span>
      <span className="font-bold text-xl">30</span>
    </div>
    <div className="ml-4">
      {/* Placeholder for percentage calculation */}
      <input
      type="number"
      className="w-16 border rounded p-2 focus:ring-0 focus:outline-none"
    />
      <span className="ml-2">%</span>
    </div>
  </div>
</div>
{/* New Section for GENERAL COMMENTS */}
<div className="border rounded-lg p-4 mt-6">
  <h3 className="text-lg font-semibold">
    GENERAL COMMENTS
  </h3>

  {/* Textarea for comments input */}
  <div className="mt-4">
    <textarea
      className="w-full border rounded-lg p-2 resize-y focus:ring-0 focus:outline-none"
      placeholder="Enter your comments here..."
      rows="4"
    />
  </div>
</div>
{/* New Row for DIRECT SUPERVISOR NAME, DIRECT SUPERVISOR'S DESIGNATION, and SIGN */}
<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
  {/* Box for DIRECT SUPERVISOR NAME */}
  <div className="border rounded-lg p-4">
    <h3 className="text-lg font-semibold">
      DIRECT SUPERVISOR NAME
    </h3>
    <input
      type="text"
      className="w-full border rounded p-2 mt-11 focus:ring-0 focus:outline-none"
      placeholder="Enter supervisor's name"
    />
  </div>

  {/* Box for DIRECT SUPERVISOR'S DESIGNATION */}
  <div className="border rounded-lg p-4">
    <h3 className="text-lg font-semibold">
      DIRECT SUPERVISOR'S DESIGNATION
    </h3>
    <input
      type="text"
      className="w-full border rounded p-2 mt-4 focus:ring-0 focus:outline-none"
      placeholder="Enter supervisor's designation"
    />
  </div>

 {/* Box for SIGN with File Upload */}
<div className="border rounded-lg p-4 relative">
  <h3 className="text-lg font-semibold">SIGNATURE</h3> {/* Blank header */}

 
  {/* Upload button for uploading signature or picture */}
  <div className="flex items-center mt-2">
    <input
      type="file"
      accept="image/*"
      className="hidden" 
      id="signatureUpload"
      onChange={(e) => handleFileUpload(e)} // Handle file change
    />
    <label
      htmlFor="signatureUpload"
      className="py-1 px-3 mt-10 bg-green-500 text-white rounded-md shadow-md cursor-pointer hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
    >
      Upload Signature
    </label>
  </div>

  {/* Preview for uploaded file and remove button */}
  {uploadedFile && (
    <div className="mt-4">
      <h4 className="font-semibold">Signature Preview:</h4>
      <img
        src={uploadedFile}
        alt="Signature preview"
        className="w-24 h-24 border rounded"
      />
      {/* Remove button */}
      <button
        onClick={handleRemoveFile}
        className="mt-2 py-1 px-3 bg-red-500 text-white rounded-md shadow-md cursor-pointer hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
      >
        Remove
      </button>
    </div>
  )}
</div>
</div>


                </div>
              </div>

              {/* Submit Button */}
              <div className="text-center mt-6">
                <button
                  type="submit"
                  className="py-2 px-4 bg-green-500 text-white rounded-md shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default FinalAssessmentForm;  
